import Combo from '@/models/Combo'
import BaseCollection from '@/models/collections/BaseCollection'

export default class ComboList extends BaseCollection {
  options () {
    return {
      model: Combo
    }
  }

  routes () {
    return {
      fetch: `${this.API_BASE}/v1/combos`
    }
  }
}
